import React, { useRef, useEffect } from "react";
import "./MobileTable.scss";
import classnames from "classnames";

function MobileTable({ columns, data }) {
  const tableRef = useRef(null);

  return (
    <div className="mobile-table-container">
      <table className="mobile-table" ref={tableRef}>
        <colgroup>
          {columns.map((column, index) => (
            <col key={column.dataIndex} style={{ width: column.width }} />
          ))}
        </colgroup>
        <thead>
          <tr>
            {columns.map((column, index) => {
              const hasNewline = /\n/.test(column?.title);
              const match = column?.title?.match(/(.+)\n(.+)/);

              let titleDom;
              if (hasNewline) {
                titleDom = (
                  <span>
                    <p>{match[1]}</p>
                    <p className="unit_line_feed">{match[2]}</p>
                  </span>
                );
              } else {
                titleDom = column.title;
              }
              return (
                <th
                  className={
                    column.fixed === "left" ? "table-cell-fix-left" : ""
                  }
                  key={column.dataIndex}
                  style={
                    column.fixed === "left"
                      ? { position: "sticky", left: column.left }
                      : null
                  }
                >
                  {titleDom}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column, columnIndex) => {
                return (
                  <td
                    className={classnames({
                      "table-cell-fix-left": column.fixed === "left",
                      "table-reach-flag": row.reachFlag === "0",
                    })}
                    key={`${rowIndex}-${columnIndex}`}
                  >
                    {row[column.dataIndex]}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default MobileTable;
